import React, { Component } from 'react';
import moment from 'moment'

class SummaryRow extends Component {
    render(){
        if(this.props.value === "title") {
            return (
                <div className="col-md-12 title-row">
                    <h5>{this.props.label}</h5>
                    {}
                </div>
            )
        }else if(this.props.value.super) {
            return (
                <div className="col-md-12 title-row">
                    { this.props.value.hide == "si" ? <h3><hr />{this.props.label}</h3> : null }
                </div>
            )
        }else if(this.props.value.title){
            return (
                <div className="col-md-12 title-row">
                    <h5>{this.props.label}: <small>{this.props.value.subtitle}</small></h5>
                </div>
            )
        }else{
            let cols = this.props.col ? "data-row col-md-"+this.props.col : "data-row col-md-6";
            return(
                <div className={cols}>
                    <span>{this.props.label}</span>
                    {this.props.value}
                </div>
            )
        }
    }
}
export default SummaryRow


// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/SummaryRow.jsx